import { render, staticRenderFns } from "./Fishery.vue?vue&type=template&id=804c6084&scoped=true&"
import script from "./Fishery.vue?vue&type=script&lang=js&"
export * from "./Fishery.vue?vue&type=script&lang=js&"
import style0 from "./Fishery.vue?vue&type=style&index=0&id=804c6084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804c6084",
  null
  
)

export default component.exports